@if (isVisible()) {
  <article class="atmos-card atmos-announcement">
    <div class="atmos-announcement__head">
      <h2 class="atmos-section__title">New design is live!</h2>
      @if (dismissable) {
        <button type="button" class="atmos-btn atmos-announcement__dismiss" aria-label="Dismiss announcement" (click)="dismiss()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>

    <div class="atmos-announcement__body">
      <p>
        Thank you for your help with the new design! I ended up getting 74 responses and have implemented a lot of the feedback.<br/>
        The changes have been deployed to <a href="https://sky-planner.com" class="atmos-text-link" target="_blank">https://sky-planner.com</a>.
      </p>
      <p>
        If you are not using Dropbox, you should transfer your data by exporting it from the
        <a [routerLink]="'/settings'" class="atmos-text-link" >Settings</a>
        and importing it on the main website to transfer your data!
      </p>
    </div>
  </article>
}
